<div class="legal-table-wrapper" aria-label="Internal Recoveries by month">
  <table class="legal-table">
    <thead>
      <tr>
        <th class="month-column">Month</th>
        @for (source of dataSources; track source) { <th>{{ source }}</th> }
        <th class="total-column">Total</th>
      </tr>
    </thead>
    <tbody>
      @if (loading) {
        @for (_ of [1, 2, 3, 4, 5, 6]; track $index) {
          <tr><td class="month-column"><span class="table-skeleton"></span></td>@for (source of dataSources; track source) { <td><span class="table-skeleton"></span></td> }<td class="total-column"><span class="table-skeleton"></span></td></tr>
        }
      } @else {
        @for (row of rows; track row.month) {
          <tr>
            <td class="month-column">{{ formatMonth(row.month) }}</td>
            @for (source of dataSources; track source) {
              <td [class.selected-value-cell]="isSelectedCell(row.month, source)"><button type="button" class="aggregate-value-button" (click)="selectCell(row.month, source)">{{ formatAmount(row.values[source]) }}</button></td>
            }
            <td class="total-column" [class.selected-value-cell]="isSelectedCell(row.month)"><button type="button" class="aggregate-value-button" (click)="selectCell(row.month)">{{ formatAmount(row.total) }}</button></td>
          </tr>
        } @empty {
          <tr><td class="empty-row" [attr.colspan]="dataSources.length + 2">No internal recoveries were found.</td></tr>
        }
      }
    </tbody>
    @if (!loading && rows.length) {
      <tfoot>
        <tr>
          <td class="month-column">Total</td>
          @for (source of dataSources; track source) { <td>{{ formatAmount(totalFor(source)) }}</td> }
          <td class="total-column">{{ formatAmount(grandTotal()) }}</td>
        </tr>
      </tfoot>
    }
  </table>
</div>
